/**
 * key 和 value 里面的 path 属性保持一致, 都是整体路由
 * value 的一些属性备注
 *     name 显示在头部菜单的内容
 *     title 显示在具体内容的标题, 大部分情况下和 name 相同, 可能存在和 name 不同
 *     hidden 是否隐藏此项, 为 true 表示隐藏, 默认 false 或 undefined
 *     routeType 路由类型, 在工具菜单内属于哪个类型 1: 卡首屏系列 2: 手淘卡屏
 *     invokeName 请求日志需要的参数
 *     priceName 请求工具价格需要的参数
 *     freeForMembers true 表示菜单展示会员免费 默认 false 或 undefined
 * 注意: menus 里面的卡首屏和手淘卡屏区分是通过 routeType, 接口里面卡首屏和手淘卡屏区分是通过 invokeName
 */
const infoData = {
    '/head_screen/recommend': {
        name: '手淘推荐',
        title: '手淘推荐',
        path: '/head_screen/recommend',
        desc: '通过手淘推荐卡屏后会跳转到手淘推荐的商品列表页，能极大的提升商品路径的访问权重',
        hidden: false, // 是否隐藏, 默认 false
        routeType: '2', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type1",
        freeForMembers: false,
        priceName: "cardFirstScreen15",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen15", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/tbmobile/nicegoods': {
        name: '有好货入口',
        title: '有好货',
        path: '/tbmobile/nicegoods',
        desc: '手淘首页的部分流量来源是手淘首页的“有好货”，此功能可以帮助你快速得到手淘首页的流量来源',
        routeType: '2', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type10",
        freeForMembers: false,
        priceName: "cardFirstScreen16",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen16", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/tbmobile/guess': {
        name: '猜你喜欢',
        title: '猜你喜欢',
        path: '/tbmobile/guess',
        desc: '使用该功能后，店铺生意参谋后台流量来源显示猜你喜欢',
        routeType: '2', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "st-guess",
        priceName: "cardFirstScreen17",
        logType: "log", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen17", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/tbmobile/hbooth': {
        name: '智钻',
        title: '智钻',
        path: '/tbmobile/hbooth',
        desc: '提供多流量来源入口，多样化流量首选',
        routeType: '2', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type14",
        freeForMembers: false,
        priceName: "cardFirstScreen18",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen18", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/tbmobile/globalshop': {
        name: '全球购入口',
        title: '全球购',
        path: '/tbmobile/globalshop',
        desc: '提供多流量来源入口，多样化流量首选',
        routeType: '2', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type16",
        freeForMembers: false,
        priceName: "cardFirstScreen19",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen19", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/tbmobile/dayshops': {
        name: '每日好店入口',
        title: '每日好店',
        path: '/tbmobile/dayshops',
        desc: '提供多流量来源入口，多样化流量首选',
        routeType: '2', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type11",
        freeForMembers: false,
        priceName: "cardFirstScreen20",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen20", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/tbmobile/robshop': {
        name: '淘抢购入口',
        title: '淘抢购',
        path: '/tbmobile/robshop',
        desc: '提供多流量来源入口，多样化流量首选',
        routeType: '2', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type12",
        freeForMembers: false,
        priceName: "cardFirstScreen21",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen21", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/head_screen/coins': {
        name: '淘金币',
        title: '淘金币',
        path: '/head_screen/coins',
        desc: '使用该功能后，店铺生意参谋后台流量来源显示淘金币',
        routeType: '2', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type22",
        priceName: "cardFirstScreen22",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen22", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/head_screen/life': {
        name: '生活研究所',
        title: '生活研究所',
        path: '/head_screen/life',
        desc: '针对手淘人群流量入口精准补流量',
        routeType: '2', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type4",
        freeForMembers: false,
        priceName: "cardFirstScreen23",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen23", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/tbmobile/iFashion': {
        name: 'iFashion',
        title: 'iFashion',
        path: '/tbmobile/iFashion',
        desc: '提供多流量来源入口，多样化流量首选',
        routeType: '2', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type15",
        freeForMembers: false,
        priceName: "cardFirstScreen24",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen24", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/head_screen/micro-details': { // 微详情要调用不同的接口, 且不同的表单, 注意
        name: '微详情',
        title: '微详情（手淘推荐）',
        path: '/head_screen/micro-details',
        desc: '使用该功能后，商品将显示在首屏',
        routeType: '1', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "kweixiangqing",
        priceName: "kweixiangqing",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "kweixiangqing", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/head_screen/ask-everyone': {
        name: '问大家',
        title: '问大家',
        path: '/head_screen/ask-everyone',
        desc: '使用该功能后，商品将显示在首屏',
        routeType: '1', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type19",
        priceName: "cardFirstScreen1",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen1", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/tbmobile/probaby': {
        name: '亲宝贝入口',
        title: '亲宝贝',
        path: '/tbmobile/probaby',
        desc: '提供多流量来源入口，多样化流量首选',
        routeType: '1', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type13",
        priceName: "cardFirstScreen2",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen2", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/head_screen/buy-ask-everyone': {
        name: '购后猜你喜欢',
        title: '购后猜你喜欢',
        path: '/head_screen/buy-ask-everyone',
        desc: '使用该功能后，商品将显示在首屏',
        routeType: '1', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type24",
        priceName: "cardFirstScreen3",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen3", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/head_screen/first-order-discount': {
        name: '首单优惠',
        title: '首单优惠',
        path: '/head_screen/first-order-discount',
        desc: '使用该功能后，商品将显示在首屏',
        routeType: '1', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type21",
        priceName: "cardFirstScreen4",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen4", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/head_screen/farm': {
        name: '芭芭农场',
        title: '芭芭农场',
        path: '/head_screen/farm',
        desc: '使用该功能后，商品将显示在首屏',
        routeType: '1', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type32",
        priceName: "cardFirstScreen5",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen5", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/head_screen/wangwang': {
        name: '手淘旺旺',
        title: '手淘旺旺',
        path: '/head_screen/wangwang',
        desc: '使用该功能后，商品将显示在首屏',
        routeType: '1', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type25",
        priceName: "cardFirstScreen6",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen6", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/head_screen/other-shop': {
        name: '手淘其它商品详情页',
        title: '手淘其它商品详情页',
        path: '/head_screen/other-shop',
        desc: '使用该功能后，商品将显示在首屏',
        routeType: '1', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type31",
        priceName: "cardFirstScreen7",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen7", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/head_screen/other-fee': {
        name: '淘内免费其它(通用版)',
        title: '淘内免费其它(通用版)',
        path: '/head_screen/other-fee',
        desc: '使用该功能后，商品将显示在首屏',
        routeType: '1', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type26",
        priceName: "cardFirstScreen8",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen8", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/head_screen/black-box': {
        name: '小黑盒',
        title: '小黑盒',
        path: '/head_screen/black-box',
        desc: '使用该功能后，商品将显示在首屏',
        routeType: '1', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type18",
        priceName: "cardFirstScreen9",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen9", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/head_screen/new-products': {
        name: '新品推荐',
        title: '新品推荐',
        path: '/head_screen/new-products',
        desc: '使用该功能后，商品将显示在首屏',
        routeType: '1', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type29",
        priceName: "cardFirstScreen10",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen10", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/checkNum/similarImport': {
        name: '相似宝贝',
        title: '相似宝贝',
        path: '/checkNum/similarImport',
        desc: '使用该功能后，商品将显示在首屏',
        routeType: '1', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type9",
        priceName: "cardFirstScreen",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/head_screen/firstPause': { // 单独做一个路又跳转, 没有其他额外的操作
        name: '【高权重】搜索卡首屏',
        title: '【高权重】搜索卡首屏',
        path: '/head_screen/firstPause',
        desc: '使用该功能后，商品将显示在首屏',
        routeType: '1', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "firstScreen",
        priceName: "seniorfirstscreen1",
        logType: "log", // log 是生成记录, qrcode 是二维码生成记录
        logName: "seniorfirstscreen1", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/head_screen/buyers-show': {
        name: '买家秀',
        title: '买家秀',
        path: '/head_screen/buyers-show',
        desc: '使用该功能后，商品将显示在首屏',
        routeType: '1', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type28",
        priceName: "cardFirstScreen11",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen11", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/head_screen/daily-deals': {
        name: '天天特卖卡首屏',
        title: '天天特卖卡首屏',
        path: '/head_screen/daily-deals',
        desc: '使用该功能后，商品将显示在首屏',
        routeType: '1', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type27",
        priceName: "cardFirstScreen12",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen12", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/head_screen/poly-cost-effective': {
        name: '聚划算品牌特卖',
        title: '聚划算品牌特卖',
        path: '/head_screen/poly-cost-effective',
        desc: '使用该功能后，商品将显示在首屏',
        routeType: '1', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type20",
        priceName: "cardFirstScreen13",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen13", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/head_screen/buy-page': {
        name: '支付页-猜你喜欢-流量来源手淘推荐',
        title: '支付页-猜你喜欢-流量来源手淘推荐',
        path: '/head_screen/buy-page',
        desc: '使用该功能后，商品将显示在首屏',
        routeType: '1', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "cardFirstScreen-type23",
        priceName: "cardFirstScreen14",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "cardFirstScreen14", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    '/checkNum/firstPause': { // 单独做一个路又跳转, 没有其他额外的操作
        name: '关键词卡首屏',
        title: '关键词卡首屏',
        path: '/checkNum/firstPause',
        desc: '',
        routeType: '1', // 路由类型 1: 卡首屏系列 2: 手淘卡屏
        invokeName: "",
        priceName: "",
    },
    // 20240313 start
    '/head_screen/everyday-low-price': {
        name: '天天低价',
        title: '天天低价',
        path: '/head_screen/everyday-low-price',
        desc: '生参后台显示访客来源：大促会场-主会场',
        routeType: '1',
        invokeName: "cardFirstScreen-type34",
        priceName: "cardFirstScreen34",
        logType: "qrcode",
        logName: "cardFirstScreen34",
    },
    '/head_screen/post-purchase-recommandations': {
        name: '购后推荐',
        title: '购后推荐',
        path: '/head_screen/post-purchase-recommandations',
        desc: '提供多流量来源入口，多样化流量首选',
        routeType: '1',
        invokeName: "cardFirstScreen-type36",
        priceName: "cardFirstScreen36",
        logType: "qrcode",
        logName: "cardFirstScreen36",
    },
    '/head_screen/tb-good-price': {
        name: '淘宝好价',
        title: '淘宝好价',
        path: '/head_screen/tb-good-price',
        desc: '提供多流量来源入口，多样化流量首选',
        routeType: '1',
        invokeName: "cardFirstScreen-type37",
        priceName: "cardFirstScreen37",
        logType: "qrcode",
        logName: "cardFirstScreen37",
    },
    '/head_screen/tnei-unclassified': {
        name: '淘内待分类-通用',
        title: '淘内待分类-通用',
        path: '/head_screen/tnei-unclassified',
        desc: '生参后台显示访客来源和成交来源都是 ：淘内待分类 - 其他',
        routeType: '1',
        invokeName: "cardFirstScreen-type39",
        priceName: "cardFirstScreen39",
        logType: "qrcode",
        logName: "cardFirstScreen39",
    },
    '/head_screen/tnei-guess-like': {
        name: '淘内待分类-猜你喜欢',
        title: '淘内待分类-猜你喜欢',
        path: '/head_screen/tnei-guess-like',
        desc: '生参后台显示访客来源和成交来源都是：淘内待分类',
        routeType: '1',
        invokeName: "cardFirstScreen-type42",
        priceName: "cardFirstScreen42",
        logType: "qrcode",
        logName: "cardFirstScreen42",
    },
    // '/head_screen/billions-subsidies': {
    //     name: '百亿补贴',
    //     title: '百亿补贴',
    //     path: '/head_screen/billions-subsidies',
    //     desc: '生参后台显示访客来源和成交来源都是：淘内待分类',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type54",
    //     priceName: "cardFirstScreen54",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen54",
    // },
    // '/head_screen/car-life': {
    //     name: '爱车生活',
    //     title: '爱车生活',
    //     path: '/head_screen/car-life',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type55",
    //     priceName: "cardFirstScreen55",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen55",
    // },
    '/head_screen/favorable-life': {
        name: '惠生活',
        title: '惠生活',
        path: '/head_screen/favorable-life',
        desc: '',
        routeType: '1',
        invokeName: "cardFirstScreen-type57",
        priceName: "cardFirstScreen57",
        logType: "qrcode",
        logName: "cardFirstScreen57",
    },
    // '/head_screen/domestic-electric-appliance': {
    //     name: '生活电器',
    //     title: '生活电器',
    //     path: '/head_screen/domestic-electric-appliance',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type58",
    //     priceName: "cardFirstScreen58",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen58",
    // },
    // '/head_screen/trend-electric-digital': {
    //     name: '潮电数码',
    //     title: '潮电数码',
    //     path: '/head_screen/trend-electric-digital',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type60",
    //     priceName: "cardFirstScreen60",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen60",
    // },
    '/head_screen/deep-in-autumn': {
        name: '踏秋季',
        title: '踏秋季',
        path: '/head_screen/deep-in-autumn',
        desc: '',
        routeType: '1',
        invokeName: "cardFirstScreen-type62",
        priceName: "cardFirstScreen62",
        logType: "qrcode",
        logName: "cardFirstScreen62",
    },
    '/head_screen/tend-fun-festival': {
        name: '潮玩节',
        title: '潮玩节',
        path: '/head_screen/tend-fun-festival',
        desc: '',
        routeType: '1',
        invokeName: "cardFirstScreen-type64",
        priceName: "cardFirstScreen64",
        logType: "qrcode",
        logName: "cardFirstScreen64",
    },
    '/head_screen/fun-season': {
        name: '趣玩季',
        title: '趣玩季',
        path: '/head_screen/fun-season',
        desc: '',
        routeType: '1',
        invokeName: "cardFirstScreen-type65",
        priceName: "cardFirstScreen65",
        logType: "qrcode",
        logName: "cardFirstScreen65",
    },
    '/head_screen/dopamine': {
        name: '多巴胺',
        title: '多巴胺',
        path: '/head_screen/dopamine',
        desc: '',
        routeType: '1',
        invokeName: "cardFirstScreen-type66",
        priceName: "cardFirstScreen66",
        logType: "qrcode",
        logName: "cardFirstScreen66",
    },
    '/head_screen/pet-day': {
        name: '爱宠日',
        title: '爱宠日',
        path: '/head_screen/pet-day',
        desc: '',
        routeType: '1',
        invokeName: "cardFirstScreen-type67",
        priceName: "cardFirstScreen67",
        logType: "qrcode",
        logName: "cardFirstScreen67",
    },
    '/head_screen/ice-festival': {
        name: '冰雪节',
        title: '冰雪节',
        path: '/head_screen/ice-festival',
        desc: '',
        routeType: '1',
        invokeName: "cardFirstScreen-type68",
        priceName: "cardFirstScreen68",
        logType: "qrcode",
        logName: "cardFirstScreen68",
    },
    '/head_screen/valentine-day': {
        name: '情人节',
        title: '情人节',
        path: '/head_screen/valentine-day',
        desc: '',
        routeType: '1',
        invokeName: "cardFirstScreen-type69",
        priceName: "cardFirstScreen69",
        logType: "qrcode",
        logName: "cardFirstScreen69",
    },
    // '/head_screen/hot-sale-shoes-boots': {
    //     name: '热卖鞋靴',
    //     title: '热卖鞋靴',
    //     path: '/head_screen/hot-sale-shoes-boots',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type70",
    //     priceName: "cardFirstScreen70",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen70",
    // },
    // '/head_screen/live-dress': {
    //     name: '服饰直播',
    //     title: '服饰直播',
    //     path: '/head_screen/live-dress',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type71",
    //     priceName: "cardFirstScreen71",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen71",
    // },
    // '/head_screen/spring-new': {
    //     name: '春季新品',
    //     title: '春季新品',
    //     path: '/head_screen/spring-new',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type72",
    //     priceName: "cardFirstScreen72",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen72",
    // },
    // '/head_screen/global-trend': {
    //     name: '全球新趋势',
    //     title: '全球新趋势',
    //     path: '/head_screen/global-trend',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type80",
    //     priceName: "cardFirstScreen80",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen80",
    // },
    // '/head_screen/global-discover': {
    //     name: '全球新发现',
    //     title: '全球新发现',
    //     path: '/head_screen/global-discover',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type81",
    //     priceName: "cardFirstScreen81",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen81",
    // },
    // '/head_screen/international-self-support': {
    //     name: '国际自营',
    //     title: '国际自营',
    //     path: '/head_screen/international-self-support',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type82",
    //     priceName: "cardFirstScreen82",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen82",
    // },
    // '/head_screen/home-appliance': {
    //     name: '家居电器',
    //     title: '家居电器',
    //     path: '/head_screen/home-appliance',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type83",
    //     priceName: "cardFirstScreen83",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen83",
    // },
    '/head_screen/home-improvement-goodies': {
        name: '家装好物',
        title: '家装好物',
        path: '/head_screen/home-improvement-goodies',
        desc: '',
        routeType: '1',
        invokeName: "cardFirstScreen-type84",
        priceName: "cardFirstScreen84",
        logType: "qrcode",
        logName: "cardFirstScreen84",
    },
    // '/head_screen/home-improvement-nice-price': {
    //     name: '家装好价',
    //     title: '家装好价',
    //     path: '/head_screen/home-improvement-nice-price',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type85",
    //     priceName: "cardFirstScreen85",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen85",
    // },
    // '/head_screen/home-must-have': {
    //     name: '宅家必备',
    //     title: '宅家必备',
    //     path: '/head_screen/home-must-have',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type86",
    //     priceName: "cardFirstScreen86",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen86",
    // },
    // '/head_screen/home-enjoy-life': {
    //     name: '家享生活',
    //     title: '家享生活',
    //     path: '/head_screen/home-enjoy-life',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type87",
    //     priceName: "cardFirstScreen87",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen87",
    // },
    // '/head_screen/fashion': {
    //     name: '服饰时尚',
    //     title: '服饰时尚',
    //     path: '/head_screen/fashion',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type88",
    //     priceName: "cardFirstScreen88",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen88",
    // },
    // '/head_screen/boutique-furniture': {
    //     name: '精品家具',
    //     title: '精品家具',
    //     path: '/head_screen/boutique-furniture',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type89",
    //     priceName: "cardFirstScreen89",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen89",
    // },
    // '/head_screen/quality-applicance': {
    //     name: '品质家电',
    //     title: '品质家电',
    //     path: '/head_screen/quality-applicance',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type90",
    //     priceName: "cardFirstScreen90",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen90",
    // },
    // '/head_screen/sport-trend': {
    //     name: '运动新潮',
    //     title: '运动新潮',
    //     path: '/head_screen/sport-trend',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type91",
    //     priceName: "cardFirstScreen91",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen91",
    // },
    // '/head_screen/sport-goodies': {
    //     name: '运动好物',
    //     title: '运动好物',
    //     path: '/head_screen/sport-goodies',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type92",
    //     priceName: "cardFirstScreen92",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen92",
    // },
    // '/head_screen/enjoy-nice-food': {
    //     name: '美食嗨吃',
    //     title: '美食嗨吃',
    //     path: '/head_screen/enjoy-nice-food',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type93",
    //     priceName: "cardFirstScreen93",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen93",
    // },
    // '/head_screen/beauty-toiletry': {
    //     name: '美妆洗护',
    //     title: '美妆洗护',
    //     path: '/head_screen/beauty-toiletry',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type94",
    //     priceName: "cardFirstScreen94",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen94",
    // },
    // '/head_screen/mother-baby': {
    //     name: '母婴亲子',
    //     title: '母婴亲子',
    //     path: '/head_screen/mother-baby',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type95",
    //     priceName: "cardFirstScreen95",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen95",
    // },
    // '/head_screen/culture': {
    //     name: '文教香氛',
    //     title: '文教香氛',
    //     path: '/head_screen/culture',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type96",
    //     priceName: "cardFirstScreen96",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen96",
    // },
    // '/head_screen/corporate-procurement': {
    //     name: '企业采购',
    //     title: '企业采购',
    //     path: '/head_screen/corporate-procurement',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type97",
    //     priceName: "cardFirstScreen97",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen97",
    // },
    // '/head_screen/corporate-culture': {
    //     name: '宠企文教',
    //     title: '宠企文教',
    //     path: '/head_screen/corporate-culture',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type98",
    //     priceName: "cardFirstScreen98",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen98",
    // },
    // '/head_screen/publish-trend': {
    //     name: '趋势发布',
    //     title: '趋势发布',
    //     path: '/head_screen/publish-trend',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type99",
    //     priceName: "cardFirstScreen99",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen99",
    // },
    // '/head_screen/supper-item': {
    //     name: '超级单品',
    //     title: '超级单品',
    //     path: '/head_screen/supper-item',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type100",
    //     priceName: "cardFirstScreen100",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen100",
    // },
    // '/head_screen/jewelry': {
    //     name: '珠宝饰品',
    //     title: '珠宝饰品',
    //     path: '/head_screen/jewelry',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type101",
    //     priceName: "cardFirstScreen101",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen101",
    // },
    // '/head_screen/brand-ceremony': {
    //     name: '品牌盛典',
    //     title: '品牌盛典',
    //     path: '/head_screen/brand-ceremony',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type102",
    //     priceName: "cardFirstScreen102",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen102",
    // },
    // '/head_screen/woman-fashion': {
    //     name: '流行女装',
    //     title: '流行女装',
    //     path: '/head_screen/woman-fashion',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type103",
    //     priceName: "cardFirstScreen103",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen103",
    // },
    // '/head_screen/subtlety-pet': {
    //     name: '精致养宠',
    //     title: '精致养宠',
    //     path: '/head_screen/subtlety-pet',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type104",
    //     priceName: "cardFirstScreen104",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen104",
    // },
    // '/head_screen/watch-eyeglasses': {
    //     name: '手表眼镜',
    //     title: '手表眼镜',
    //     path: '/head_screen/watch-eyeglasses',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type105",
    //     priceName: "cardFirstScreen105",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen105",
    // },
    // '/head_screen/health-life': {
    //     name: '健康生活',
    //     title: '健康生活',
    //     path: '/head_screen/health-life',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type106",
    //     priceName: "cardFirstScreen106",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen106",
    // },
    // '/head_screen/kitchenette': {
    //     name: '厨房家居',
    //     title: '厨房家居',
    //     path: '/head_screen/kitchenette',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type107",
    //     priceName: "cardFirstScreen107",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen107",
    // },
    // '/head_screen/pre-enjoy-trend': {
    //     name: '潮玩早享',
    //     title: '潮玩早享',
    //     path: '/head_screen/pre-enjoy-trend',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type108",
    //     priceName: "cardFirstScreen108",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen108",
    // },
    // '/head_screen/bedding-home-decor': {
    //     name: '床品家饰',
    //     title: '床品家饰',
    //     path: '/head_screen/bedding-home-decor',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type109",
    //     priceName: "cardFirstScreen109",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen109",
    // },
    // '/head_screen/spring-newest': {
    //     name: '春季上新',
    //     title: '春季上新',
    //     path: '/head_screen/spring-newest',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type110",
    //     priceName: "cardFirstScreen110",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen110",
    // },
    '/head_screen/tmall-u-first': {
        name: '天猫U先',
        title: '天猫U先',
        path: '/head_screen/tmall-u-first',
        desc: '',
        routeType: '1',
        invokeName: "cardFirstScreen-type112",
        priceName: "cardFirstScreen112",
        logType: "qrcode",
        logName: "cardFirstScreen112",
    },
    // '/head_screen/tmall-market': {
    //     name: '天猫超市',
    //     title: '天猫超市',
    //     path: '/head_screen/tmall-market',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type115",
    //     priceName: "cardFirstScreen115",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen115",
    // },
    // '/head_screen/tmall-medicine': {
    //     name: '天猫买药',
    //     title: '天猫买药',
    //     path: '/head_screen/tmall-medicine',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type118",
    //     priceName: "cardFirstScreen118",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen118",
    // },
    // '/head_screen/brand-digital': {
    //     name: '大牌数码',
    //     title: '大牌数码',
    //     path: '/head_screen/brand-digital',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type119",
    //     priceName: "cardFirstScreen119",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen119",
    // },
    // '/head_screen/brand-jewelry': {
    //     name: '大牌珠宝',
    //     title: '大牌珠宝',
    //     path: '/head_screen/brand-jewelry',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type120",
    //     priceName: "cardFirstScreen120",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen120",
    // },
    // '/head_screen/brand-mother-baby': {
    //     name: '大牌母婴',
    //     title: '大牌母婴',
    //     path: '/head_screen/brand-mother-baby',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type121",
    //     priceName: "cardFirstScreen121",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen121",
    // },
    // '/head_screen/brand-home-cleaner': {
    //     name: '大牌家清',
    //     title: '大牌家清',
    //     path: '/head_screen/brand-home-cleaner',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type122",
    //     priceName: "cardFirstScreen122",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen122",
    // },
    // '/head_screen/brand-personal-care': {
    //     name: '大牌个护',
    //     title: '大牌个护',
    //     path: '/head_screen/brand-personal-care',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type123",
    //     priceName: "cardFirstScreen123",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen123",
    // },
    // '/head_screen/brand-beauty': {
    //     name: '大牌美妆',
    //     title: '大牌美妆',
    //     path: '/head_screen/brand-beauty',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type124",
    //     priceName: "cardFirstScreen124",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen124",
    // },
    // '/head_screen/brand-man-clothes': {
    //     name: '大牌男装',
    //     title: '大牌男装',
    //     path: '/head_screen/brand-man-clothes',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type125",
    //     priceName: "cardFirstScreen125",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen125",
    // },
    // '/head_screen/brand-undergarments': {
    //     name: '大牌内衣',
    //     title: '大牌内衣',
    //     path: '/head_screen/brand-undergarments',
    //     desc: '',
    //     routeType: '1',
    //     invokeName: "cardFirstScreen-type126",
    //     priceName: "cardFirstScreen126",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen126",
    // },
    // 20240313 end

    // 20240306 start
    '/tbmobile/brand-undergarments': {
        name: 'U先试用',
        title: 'U先试用',
        path: '/tbmobile/brand-undergarments',
        desc: '提供多流量来源入口，多样化流量首选',
        routeType: '2',
        invokeName: "cardFirstScreen-type33",
        priceName: "cardFirstScreen33",
        logType: "qrcode",
        logName: "cardFirstScreen33",
    },
    '/tbmobile/tm-live': {
        name: '手淘直播',
        title: '手淘直播',
        path: '/tbmobile/tm-live',
        desc: '生参后台显示访客来源：平台流量-手淘淘宝直播',
        routeType: '2',
        invokeName: "cardFirstScreen-type38",
        priceName: "cardFirstScreen38",
        logType: "qrcode",
        logName: "cardFirstScreen38",
    },
    '/tbmobile/tnei-discover': {
        name: '淘内待分类-精选发现',
        title: '淘内待分类-精选发现',
        path: '/tbmobile/tnei-discover',
        desc: '生参后台显示访客来源和成交来源都是：淘内待分类',
        routeType: '2',
        invokeName: "cardFirstScreen-type40",
        priceName: "cardFirstScreen40",
        logType: "qrcode",
        logName: "cardFirstScreen40",
    },
    '/tbmobile/tnei-recommandations': {
        name: '淘内待分类-为你推荐',
        title: '淘内待分类-为你推荐',
        path: '/tbmobile/tnei-recommandations',
        desc: '生参后台显示访客来源和成交来源都是：淘内待分类',
        routeType: '2',
        invokeName: "cardFirstScreen-type41",
        priceName: "cardFirstScreen41",
        logType: "qrcode",
        logName: "cardFirstScreen41",
    },
    '/tbmobile/tmr-topic-cloud': {
        name: '手淘推荐云主题',
        title: '手淘推荐云主题',
        path: '/tbmobile/tmr-topic-cloud',
        desc: '生参后台显示访客来源和成交来源都是：手淘推荐-推荐云主题',
        routeType: '2',
        invokeName: "cardFirstScreen-type43",
        priceName: "cardFirstScreen43",
        logType: "qrcode",
        logName: "cardFirstScreen43",
    },
    '/tbmobile/tm-must-list': {
        name: '手淘必买清单',
        title: '手淘必买清单',
        path: '/tbmobile/tm-must-list',
        desc: '生参后台显示访客来源和成交来源都是：手淘必买清单 - 手淘客户端APP必买清单',
        routeType: '2',
        invokeName: "cardFirstScreen-type44",
        priceName: "cardFirstScreen44",
        logType: "qrcode",
        logName: "cardFirstScreen44",
    },
    '/tbmobile/details-main-img': {
        name: '详情页头图推荐',
        title: '详情页头图推荐',
        path: '/tbmobile/details-main-img',
        desc: '访客通过手淘其他店铺的商品详情页引导进入您的商品详情页，如访客通过商品头图横向滑动至最右侧查看更多商品，会将您的商品通过系统推荐算法展示在更多相似宝贝的集合页面上。因为商品是系统推荐的，如果您店铺里的优秀商品很多，要补的商品是新品的话有可能无法卡到！生参后台会显示来源：手淘其他店铺详情 - 商品详情页头图推荐',
        routeType: '2',
        invokeName: "cardFirstScreen-type45",
        priceName: "cardFirstScreen45",
        logType: "qrcode",
        logName: "cardFirstScreen45",
    },
    // '/tbmobile/short-video-fullpage': {
    //     name: '短视频全屏页',
    //     title: '短视频全屏页',
    //     path: '/tbmobile/short-video-fullpage',
    //     desc: '视频ID在千牛端内容管理获取或者 光合平台 作品管理获取。全屏页短视频（猜你喜欢短视频）内容定位为导购型短视频。短视频全屏页上下滑，指访客通过短视频全屏页上下滑页面，直接引导进入店铺或商品详情页的流量。通过光合视频生成的入口二维码，让买手进行干预点赞。可以被公域推荐获取手淘推荐的流量',
    //     routeType: '2',
    //     invokeName: "cardFirstScreen-type46",
    //     priceName: "cardFirstScreen46",
    //     logType: "qrcode",
    //     logName: "cardFirstScreen46",
    // },
    '/tbmobile/tm-nice-price': {
        name: '手淘有好价',
        title: '手淘有好价',
        path: '/tbmobile/tm-nice-price',
        desc: '生参后台显示访客来源：淘宝免费流量 - 手淘有好价',
        routeType: '2',
        invokeName: "cardFirstScreen-type47",
        priceName: "cardFirstScreen47",
        logType: "qrcode",
        logName: "cardFirstScreen47",
    },
    '/tbmobile/tm-plt': {
        name: '手淘拍立淘',
        title: '手淘拍立淘',
        path: '/tbmobile/tm-plt',
        desc: '生参后台显示访客来源：手淘拍立淘',
        routeType: '2',
        invokeName: "cardFirstScreen-type48",
        priceName: "cardFirstScreen48",
        logType: "qrcode",
        logName: "cardFirstScreen48",
    },
    '/tbmobile/tm-nice-goodies': {
        name: '淘宝好货推荐',
        title: '淘宝好货推荐',
        path: '/tbmobile/tm-nice-goodies',
        desc: '生参后台显示访客来源：淘内待分类',
        routeType: '2',
        invokeName: "cardFirstScreen-type49",
        priceName: "cardFirstScreen49",
        logType: "qrcode",
        logName: "cardFirstScreen49",
    },
    '/tbmobile/tiny-black-box': {
        name: '小黑盒卡首屏',
        title: '小黑盒卡首屏',
        path: '/tbmobile/tiny-black-box',
        desc: '生参后台显示访客来源：天猫小黑盒',
        routeType: '2',
        invokeName: "cardFirstScreen-type51",
        priceName: "cardFirstScreen51",
        logType: "qrcode",
        logName: "cardFirstScreen51",
    },
    '/tbmobile/guess-your-like-star': {
        name: '猜你喜欢小星星',
        title: '猜你喜欢小星星',
        path: '/tbmobile/guess-your-like-star',
        desc: '生参后台显示访客来源：淘内免费其他',
        routeType: '2',
        invokeName: "cardFirstScreen-type52",
        priceName: "cardFirstScreen52",
        logType: "qrcode",
        logName: "cardFirstScreen52",
    },
    '/tbmobile/first-order-coupon': {
        name: '首单优惠礼金卡首页',
        title: '首单优惠礼金卡首页',
        path: '/tbmobile/first-order-coupon',
        desc: '首单礼金报名https://tmallxrl.sale.tmall.com/activity/marketActivitys.htm 。 1、精准定向新客； 2、自主选择新客拉新费率； 3、先成交后结算； 4、计入店铺成交； 5、全链路氛围打标。 面向新客的高效拉新工具，宝贝所在类目的商品拉新力指数排名，进行实时赛马和星级打分，将商品分成2-5星，星级越高，商品拉新效能越好',
        routeType: '2',
        invokeName: "cardFirstScreen-type53",
        priceName: "cardFirstScreen53",
        logType: "qrcode",
        logName: "cardFirstScreen53",
    },
    '/tbmobile/taobao-foodie': {
        name: '淘宝吃货',
        title: '淘宝吃货',
        path: '/tbmobile/taobao-foodie',
        desc: '',
        routeType: '2',
        invokeName: "cardFirstScreen-type56",
        priceName: "cardFirstScreen56",
        logType: "qrcode",
        logName: "cardFirstScreen56",
    },
    '/tbmobile/trend-play': {
        name: '潮玩世界',
        title: '潮玩世界',
        path: '/tbmobile/trend-play',
        desc: '',
        routeType: '2',
        invokeName: "cardFirstScreen-type59",
        priceName: "cardFirstScreen59",
        logType: "qrcode",
        logName: "cardFirstScreen59",
    },
    '/tbmobile/holiday-guide': {
        name: '节日指南',
        title: '节日指南',
        path: '/tbmobile/holiday-guide',
        desc: '',
        routeType: '2',
        invokeName: "cardFirstScreen-type63",
        priceName: "cardFirstScreen63",
        logType: "qrcode",
        logName: "cardFirstScreen63",
    },
    '/tbmobile/piece-house': {
        name: '每平每屋',
        title: '每平每屋',
        path: '/tbmobile/piece-house',
        desc: '',
        routeType: '2',
        invokeName: "cardFirstScreen-type73",
        priceName: "cardFirstScreen73",
        logType: "qrcode",
        logName: "cardFirstScreen73",
    },
    '/tbmobile/my-cute-pets': {
        name: '我的萌宠',
        title: '我的萌宠',
        path: '/tbmobile/my-cute-pets',
        desc: '',
        routeType: '2',
        invokeName: "cardFirstScreen-type74",
        priceName: "cardFirstScreen74",
        logType: "qrcode",
        logName: "cardFirstScreen74",
    },
    '/tbmobile/cat-fresh-food': {
        name: '喵鲜生',
        title: '喵鲜生',
        path: '/tbmobile/cat-fresh-food',
        desc: '',
        routeType: '2',
        invokeName: "cardFirstScreen-type75",
        priceName: "cardFirstScreen75",
        logType: "qrcode",
        logName: "cardFirstScreen75",
    },
    '/tbmobile/trend-woo': {
        name: '潮WOO',
        title: '潮WOO',
        path: '/tbmobile/trend-woo',
        desc: '',
        routeType: '2',
        invokeName: "cardFirstScreen-type76",
        priceName: "cardFirstScreen76",
        logType: "qrcode",
        logName: "cardFirstScreen76",
    },
    '/tbmobile/cool-planet': {
        name: '酷玩星球',
        title: '酷玩星球',
        path: '/tbmobile/cool-planet',
        desc: '',
        routeType: '2',
        invokeName: "cardFirstScreen-type77",
        priceName: "cardFirstScreen77",
        logType: "qrcode",
        logName: "cardFirstScreen77",
    },
    '/tbmobile/odp': {
        name: '海外直购',
        title: '海外直购',
        path: '/tbmobile/odp',
        desc: '',
        routeType: '2',
        invokeName: "cardFirstScreen-type78",
        priceName: "cardFirstScreen78",
        logType: "qrcode",
        logName: "cardFirstScreen78",
    },
    '/tbmobile/global-purchase': {
        name: '全球购',
        title: '全球购',
        path: '/tbmobile/global-purchase',
        desc: '',
        routeType: '2',
        invokeName: "cardFirstScreen-type79",
        priceName: "cardFirstScreen79",
        logType: "qrcode",
        logName: "cardFirstScreen79",
    },
    '/tbmobile/tm-neighbor-goodies': {
        name: '邻家好货手淘',
        title: '邻家好货手淘',
        path: '/tbmobile/tm-neighbor-goodies',
        desc: '生参后台显示访客来源：手淘其他店铺商品详情',
        routeType: '2',
        invokeName: "cardFirstScreen-type50",
        priceName: "cardFirstScreen50",
        logType: "qrcode",
        logName: "cardFirstScreen50",
    },
    '/tbmobile/tmall-international': {
        name: '天猫国际',
        title: '天猫国际',
        path: '/tbmobile/tmall-international',
        desc: '',
        routeType: '2',
        invokeName: "cardFirstScreen-type111",
        priceName: "cardFirstScreen111",
        logType: "qrcode",
        logName: "cardFirstScreen111",
    },
    '/tbmobile/tmall-luxury': {
        name: '天猫奢品',
        title: '天猫奢品',
        path: '/tbmobile/tmall-luxury',
        desc: '',
        routeType: '2',
        invokeName: "cardFirstScreen-type113",
        priceName: "cardFirstScreen113",
        logType: "qrcode",
        logName: "cardFirstScreen113",
    },
    '/tbmobile/tmall-apple-fans': {
        name: '天猫果粉',
        title: '天猫果粉',
        path: '/tbmobile/tmall-apple-fans',
        desc: '',
        routeType: '2',
        invokeName: "cardFirstScreen-type114",
        priceName: "cardFirstScreen114",
        logType: "qrcode",
        logName: "cardFirstScreen114",
    },
    '/tbmobile/tmall-list': {
        name: '天猫榜单',
        title: '天猫榜单',
        path: '/tbmobile/tmall-list',
        desc: '',
        routeType: '2',
        invokeName: "cardFirstScreen-type116",
        priceName: "cardFirstScreen116",
        logType: "qrcode",
        logName: "cardFirstScreen116",
    },
    // 20240306 end
    '/tbmobile/tmall-creation': {
        name: '天猫造新',
        title: '天猫造新',
        path: '/tbmobile/tmall-creation',
        desc: '',
        routeType: '2',
        invokeName: "cardFirstScreen-type117",
        priceName: "cardFirstScreen117",
        logType: "qrcode",
        logName: "cardFirstScreen117",
    },
}

export {
    infoData,
}
